(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'QuickAddComment',
	};
	var $modal_body;
	var $container;
	var form_id = 'quickaddcomment-';

	var QuickActions = {};

	QuickActions.entities = [
		'reservation',
		'client',
		'group',
	];

	QuickActions.entity_type = null;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
		$modal_body = $('.modal-body');
		$container  = $('.modal');

		$container.on('change', '.qa-reference-select', function _changeEntity() {
			var classification = $('#' + form_id + 'classification').val();
			var task_entities  = QuickActions.entities.slice();

			// reset popup checkboxes
			$.each(task_entities, function onEachEntity(i, entity) {
				$('div[data-entity="' + entity + '_popup"]').addClass('hidden');
			});

			// reset the typeaheads
			$.each(task_entities, function onEachEntity(i, entity) {
				$('.reset-' + entity + '-typeahead').trigger('click');
			});

			// hide the entity fields
			// hide entities specific typeaheads and based on fields
			$.each(task_entities, function onEachEntity(i, entity) {
				$('.' + entity + '-typeahead').addClass('hidden');
			});

			if (classification === '') {
				// "None" classification selected, display typeahead to
				// select a task list manually
			} else {
				$('.' + classification + '-typeahead').removeClass('hidden');
				$('div[data-entity="' + classification + '_popup"]').removeClass('hidden');

				if (classification === 'reservation') {
					$('.travel-type-field').removeClass('hidden');
				}
			}
		});
	});

	form.load = function load()
	{
		var task_entities = QuickActions.entities.slice();
		var entity = $('.entity-chip');

		loadAjaxTypeahead();

		Adzuki.Editor('#' + form_id + 'comment', {
			height                  : 200,
			content_css             : $('#' + form_id + 'comment').data('content-css'),
			table_default_attributes: {
					class: 'table'
			}
		});

		// Adzuki.Form.initAjaxForm('QuickAddComment');

		if (entity.is(":visible")) {
			$('.qa-reference').addClass('hidden');
		}

		// click on button to reset entity typeahead
		$.each(task_entities, function onEachEntity(i, entity) {
			$('.reset-' + entity + '-typeahead').click( function onClickResetTypeahead(e) {
				e.preventDefault();

				// hide reset button and reset typeahead fields
				$('.reset-' + entity + '-typeahead').addClass('hidden');
				$('#' + form_id + entity + '_search').prop('disabled', false);
				$('#' + form_id + entity + '_search').val('');
				$('#' + form_id + entity + '_id').val('').trigger('change');
			});
		});

		// when closing the entity chip
		$('.entity-chip .remove-reference').off().on('click', function onReferenceRemove(e)
		{
			$('#quick_add_comment .entity-chip').addClass('hidden');
			$('#quick_add_comment .classification-field').removeClass('hidden');

			// reset classification fields so a new one can be selected
			$('#quick_add_comment #' + form_id + 'classification').val('').trigger('change');
		});
	};

	form.success = function success(response)
	{
		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		// show success message and re-render the form on success
		Adzuki.StatusMessage(
			'success',
			'The comment has been saved.',
			'Success',
			{
				onClose: function onAlertClosed() {
					_renderQuickCommentForm();
			}
		});
	};

	function _renderQuickCommentForm()
	{
		Adzuki.Ajax.get('/QuickActions/loadQuickComment/')
		.then(function success(data) {
			$modal_body.find('.qa-add-comment').html(data);

			Adzuki.Form.initAjaxForm('QuickAddComment');
		});
	}

	function loadAjaxTypeahead(include_cancelled = false) {

		// comment reservation search typeahead
		Adzuki.Typeahead(
			$('#' + form_id + 'reservation_search'),
			function source(term, display, $self) {
				var url = '/Reservations/searchReservations/' + term;

				if (include_cancelled) {
					url += '/1';
				}
				$self.removeClass('ajax-spinner');
				Adzuki.Ajax.get(url).then(function reservationSearch(response) {
					$self.removeClass('ajax-spinner');
					display(response);
				});
			},
			function onSelect(reservation, $self, typeahead) {
				$self.prop('disabled', true);
				$('#' + form_id + 'reservation_vendor_id').val(reservation.reservation_vendor_id);
				$('#' + form_id + 'reservation_id').val(reservation.id).trigger('change');
				$('.reset-reservation-typeahead').removeClass('hidden');
			}
		);

		// comment client search typeahead
		Adzuki.Typeahead(
			$('#' + form_id + 'client_search'),
			'/Clients/search',
			function onSelect(client, $self, typeahead) {
				$self.prop('disabled', true);
				$('#' + form_id + 'client_id').val(client.id).trigger('change');
				$('.reset-client-typeahead').removeClass('hidden');
			}
		);

		// comment group search typeahead
		Adzuki.Typeahead(
			$('#' + form_id + 'group_search'),
			'/Groups/searchPrivateGroupsTypeahead',
			function onSelect(group, $self, typeahead) {
				$self.prop('disabled', true);
				$('#' + form_id + 'group_id').val(group.id).trigger('change');
				$('.reset-group-typeahead').removeClass('hidden');
			}
		);
	}

}(jQuery, window.Adzuki || {}));
